import * as yup from 'yup';

export const CommisionerValidationSchema = yup.object().shape(
    {
        IsBusinessUnderInvestigation: yup
            .boolean()
            .nullable()
            .required("Please indicate if your business was under investigation."),

        HasReportedToBeeCommisioner: yup
            .boolean()
            .nullable()
            .required("Please indicate if there were any report/dealigs with the BBEE Commission."),

        BusinessUnderInvestigationDetail: yup.string().nullable().max(1000, 'Must be less than 1000 characters'),
        ReportedToBEECommisionerDetail: yup.string().nullable().max(1000, 'Must be less than 1000 characters')
    }
);
